import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FileModel, FileUpload} from '../../models/file.model';
import {DocumentsApiService} from '../api/documents-api.service';
import {AlertService} from '../notify/alert.service';
import {FileQueueService} from '../file-queue.service';
import {DocumentsServiceService} from '../../controllers/documents/documents-service.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class DocumentHelpersService {

    constructor(
        protected documentService: DocumentsApiService,
        protected alertService: AlertService,
        protected fileQueueService: FileQueueService,
        public controller: DocumentsServiceService,
        protected translate: TranslateService,
    ) {
    }

    fileExpansion(value: string | number): string {
        const icons = {
            folder: 'folder',
            collection: 'bookmarks',
            file: 'file',
        };

        return icons[value];
    }

    /**
     * Загрузка файла
     * @param directory folder || collection
     * @param dirId
     * @param file
     */
    uploadFile(directory: string = 'folder', dirId: number = null, file): Observable<any> {
        if (!dirId) {
            this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_COLLECTION'), 'blue');
            return;
        }
        if (directory === 'folder') {
            return this.documentService.createFile(file);
        } else if (directory === 'collection') {
            return this.documentService.uploadFileInCollection(file, dirId);
        }
    }

    /**
     * Добавление файла в коллекцию
     * @param file
     * @param collectionId
     */
    uploadInCollection(file: FileUpload, collectionId: number): void {
        this.documentService.uploadFileInCollection(file.source, collectionId).subscribe({
            next: data => {
                this.setFileToQueue(data);
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }

    /**
     * Отправка файла в интерфейсный файловый менеджер
     * @param data
     * Результат с сервера
     * @param refresh
     * Обновление таблицы
     */
    setFileToQueue(data, refresh: boolean = true): void {
        this.fileQueueService.findNewTask();
        this.alertService.setAlert('<b>' + data.message + '</b>', 'green');

        if (refresh) {
            this.controller.loadNav();
        }
    }

    /**
     * @param file
     * Объект файла; Обновление версии файла
     * @param newVersionData
     */
    updateFileVersion(file: FileModel, newVersionData): Observable<any> {
        return new Observable(subscriber => {
            this.documentService.updateFile(file, {
                document: newVersionData.file,
                file_description: newVersionData.desc,
            }).subscribe({
                next: (data2: any) => {
                    this.setFileToQueue(data2, false);
                    subscriber.next(data2);
                    subscriber.complete();
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                    subscriber.complete();
                },
            });
        });
    }
}
